<template>
<div class="terms">
  <body
    class="account-page"
    style="font-family: 'CircularStd', sans-serif;
    font-size: .9375rem;
    color: #1f1f1f;
    background-color: #f7f7f7;
    min-height: 100%;
    overflow-x: hidden;
    
    "
  >
    <div class="main-wrapper">
      <!-- <layout-header></layout-header> -->
      <!-- <layout-sidebar></layout-sidebar> -->
      <!-- Page Wrapper -->
      <div class="account-content">
        <div class="container">
          <!-- Account Logo -->
          <div class="account-logo">
            <router-link to="/index">
              <img v-bind:src="logoText" :alt="appTitle" />
            </router-link>
          </div>
        </div>
        <!-- Page Content -->
        <div class="row">
          <div class="col-sm-12">
            <div class="content">
              <div class="small-container">
                <div class="inner-header text-center">
                  <h1>Kebijakan Privasi Waajo</h1>(Terakhir diperbarui tanggal: 1 Maret 2023)
                </div>
                <div class="inner-content">
                  <p>
                    <i>MOHON UNTUK MEMBACA SELURUH SYARAT DAN KETENTUAN PENGGUNAAN SERTA KEBIJAKAN PRIVASI YANG TERLAMPIR DENGAN CERMAT DAN SAKSAMA SEBELUM MENGGUNAKAN SETIAP FITUR DAN/ATAU LAYANAN YANG TERSEDIA DALAM PLATFORM WAAJO.ID.</i>
                  </p>
                  <p
                    class="lead"
                  >Waajo sangat berkomitmen untuk melindungi privasi pelanggan. Kami menulis kebijakan privasi ini untuk menjelaskan informasi yang kami kumpulkan dan bagaimana kami menggunakan informasi ini. Melindungi privasi Anda adalah bagian penting dari komitmen kami untuk menyediakan pengalaman pelayanan kami.</p>

                  <h3>Ketentuan Umum</h3>
                  <p>
                    <ul>
                      <li>
                        Platform Waajo adalah aplikasi web (aplikasi yang dapat diakses menggunakan web), website yang dikelola oleh Kami sebagaimana diperbarui dari waktu ke waktu.
                    
                      </li>
                      <li>
                         Koneksi internet diperlukan untuk dapat menggunakan Layanan dan biaya terkait penggunaan koneksi internet tersebut ditanggung sepenuhnya oleh Anda.
                   
                      </li>
                      <li>
                         Platform Waajo berfungsi sebagai sarana untuk menghubungkan whatsapp anda dengan waajo.id (“Penyedia Layanan”) untuk menambah fitur. Platform ini menggunakan Whatsapp unofficial sehingga segala sesuatu yang timbul terkait penggunaan Waajo menjadi tanggung jawab penuh dari pelanggan dan pihak Waajo tidak memiliki kewajiban penggantian terhadap kerugian yang ditimbulkan.
                   
                      </li>
                      <li>
                        Kami dapat menggunakan jasa pihak ketiga terkait penyediaan layanan pembayaran. Apabila terjadi kegagalan pada sistem pembayaran, Kami akan berupaya semaksimal mungkin dalam membantu menyelesaikan masalah yang mungkin timbul. Penyedia jasa perbankan/pembayaran yang dipilih oleh Anda dapat mengenakan biaya tambahan kepada Anda atas layanan yang diberikan
                    
                      </li>
                      <li>
                            Dengan menggunakan Waajo, Anda memahami dan menyetujui bahwa percakapan melalui fitur chat akan tersimpan secara otomatis dan diarsipkan untuk keperluan legal dan peningkatan kualitas layanan. Kerahasiaan percakapan Anda terjamin dan informasi tidak akan disebarluaskan.
                
                      </li>
                    </ul>
                  </p>
                  
                  <h3>Pengumpulan dan Penggunaan Informasi</h3>
                  <p>
                    Kami adalah pemilik tunggal dari informasi yang dikumpulkan di situs ini. Kami tidak akan pernah menjual, berbagi, atau menyewakan informasi ini kepada orang lain. Kerahasiaan seluruh data Anda terjamin  di Waajo tidak untuk disebarkan kepada pihak lain.
                  </p>

                    <h3>Pemesanan</h3>
                  <p>Untuk pelanggan yang melakukan pemesanan, kami meminta informasi pribadi pada formulir pemesanan seperti Kontak (nama, no telp, email, dll). Informasi ini digunakan untuk tujuan menghubungi pelanggan terkait pemesanan.</p>

                    <h3>Pemberitahuan Perubahan</h3>
                  <p>Jika kami memutuskan untuk mengubah kebijakan privasi kami, kami akan menyampaikan perubahan itu di halaman ini sehingga pengguna kami akan selalu mengetahui informasi apa yang kami kumpulkan, bagaimana kami menggunakannya. Kami akan menggunakan informasi sesuai dengan kebijakan privasi di mana informasi dikumpulkan.</p>

                    <h3>Feedback Anda</h3>
                  <p>Di Waajo, privasi Anda sangat penting. Jika Anda memiliki pertanyaan tentang pernyataan privasi, praktik situs ini, atau transaksi Anda dengan kami, silahkan hubungi kami dan beritahu kami.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </body>
</div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      showCouponCode: 0,
      appTitle: process.env.VUE_APP_TITLE,
      logoText: process.env.VUE_APP_LOGO_TEXT
    };
  },
  name: "terms"
};
</script>


// WEBPACK FOOTER //
// src/views/page/terms.vue